import React from 'react'
import config from 'isomorphic-config'
import PclnUcChatBot, {
  HandleMarkerResponse,
  localCache
} from '@pcln/uc-chat-bot'
import { v4 as uuidv4 } from 'uuid'
import useBootstrapData from '@/hooks/useBootstrapData'
import analytics from '@/shared-utils/analytics'
import { LOCATION_SEARCH_TYPE } from '@/types'
import getCityListComponent from './getCityListComponent'

const JSONOBJECT_CITIES = 'JSONOBJECT_CITIES'
const MODAL_ARIA_LABEL = 'Travel Bot Chat Dialog Modal'
const MODAL_ARIA_TITLE = 'Travel Bot Chat Dialog'

export const handleMarkerResponse: HandleMarkerResponse = (
  err,
  marker,
  fullText
) => {
  try {
    if (err) {
      throw err
    } else if (marker === JSONOBJECT_CITIES) {
      return {
        role: 'assistant',
        content: '',
        promptContent: 'Displayed city list to the user.',
        markerComponentProps: { prefixString: fullText }
      }
    }
  } catch (error) {
    const catchErrorMessage = JSON.stringify(error)

    analytics.logError({
      message: `ChatBot - handle marker response error: ${catchErrorMessage}`
    })

    return {
      role: 'assistant',
      content: 'Network error, please retry.'
    }
  }
}

function TravelChatBotModal(props: {
  isChatBotDialogOpened: boolean
  onModalClose: () => void
  onLocationSelect: (item: LOCATION_SEARCH_TYPE) => void
}) {
  const { isChatBotDialogOpened, onModalClose, onLocationSelect } = props

  const markerComponents = {
    [JSONOBJECT_CITIES]: getCityListComponent(onLocationSelect)
  }

  const {
    isMobile,
    webstats,
    customer: { firstName }
  } = useBootstrapData()

  const mobileHeaderValue = 'Y'

  return (
    <PclnUcChatBot
      chatContainerHeight="85%"
      onClose={onModalClose}
      dialogOverlayProps={{
        ariaDescription: MODAL_ARIA_LABEL,
        ariaTitle: MODAL_ARIA_TITLE
      }}
      markerComponents={markerComponents}
      handleMarkerResponse={handleMarkerResponse}
      isMobile={isMobile}
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      logFirstMessageSubmitted={() => {}}
      fetchRequestOptions={{
        url: `${config.client.uc.chatbot}?shouldUseSearchHotelsFeature=y`,
        headers: {
          'x-request-from': 'homePage',
          'x-is-mobile': mobileHeaderValue,
          'x-model-version': '4'
        }
      }}
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      onChatDialogRendered={() => {}} // not needed right now, the analytics event is fired elsewhere on open
      isChatBoxOpened={isChatBotDialogOpened}
      cachedPrompts={localCache.getLocalPrompts()}
      cachedMessages={localCache.getLocalMessages()}
      setCachedPrompts={localCache.setLocalPrompts}
      setCachedMessages={localCache.setLocalMessages}
      submitChatMessagesPayload={{
        hotelPayload: {
          shouldUseSearchHotelsFeature: true
        },
        customerName: firstName,
        productId: 5,
        rguid: `HOMEPAGE-${uuidv4()}`,
        cguid: webstats?.clientGUID,
        dateToday: new Date().toString(),
        returnJSONResponse: true
      }}
    />
  )
}

TravelChatBotModal.displayName = 'TravelChatBotModal'

export default TravelChatBotModal
